import { createReducer, on } from '@ngrx/store';
import * as DestinationsActions from '../actions/destinations.actions';
import { Utils } from '../../../services/Utils';
import {Destination} from '../../../services/api/destinations/destination.model';
import {manyDestinationsDeleted} from '../actions/destinations.actions';
import {UUID} from '../../../shared/types/uuid.type';

export const destinationsFeatureKey = 'destinations';

export interface State {
  record: Destination[];
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: [],
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(DestinationsActions.loadDestinations, (state: State): State => ({
    ...state,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(DestinationsActions.loadDestinationsSuccess, (_state: State, action): State => ({
    record: Utils.naturalSortArrayByKey(action.data, 'name'),
    error: null,
    loaded: true,
    loading: false,
  })),
  on(DestinationsActions.loadDestinationsFailure, (_state: State, action): State => ({
    record: [],
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(DestinationsActions.manyDestinationsStarted, (state: State, action: {ids: UUID[]}): State => {
    const ids: UUID[] = action.ids;
    const record: Destination[] = state.record.map((destination: Destination): Destination => {
      const id: UUID = destination.id;
      if (ids.includes(id)) {
        return {...destination, isRunning: true};
      }

      return destination;
    });

    return {
      record: record,
      error: null,
      loaded: true,
      loading: false,
    };
  }),
  on(DestinationsActions.manyDestinationsStopped, (state: State, action: {ids: UUID[]}): State => {
    const ids: UUID[] = action.ids;
    const record: Destination[] = state.record.map((destination: Destination): Destination => {
      const id: UUID = destination.id;
      if (ids.includes(id)) {
        return {...destination, isRunning: false};
      }

      return destination;
    });

    return {
      record: record,
      error: null,
      loaded: true,
      loading: false,
    };
  }),
  on(manyDestinationsDeleted, (state: State, action: {ids: UUID[]}): State => {
    const ids: UUID[] = action.ids;
    const record: Destination[] = state.record.filter((destination: Destination): boolean => {
      const id: UUID = destination.id;
      return !ids.includes(id);
    });

    return {
      record: record,
      error: null,
      loaded: true,
      loading: false,
    };
  }),
  on(DestinationsActions.clearDestinationsState, (): State => ({
    record: [],
    error: null,
    loaded: false,
    loading: false,
  })),
);
